export enum DecisionType {
	Boolean = 'boolean',
	String = 'string',
	Number = 'number',
}

export interface DecisionPoint {
	id: string;
	type: DecisionType;
	booleanValue?: boolean;
	stringValue?: string;
	numberValue?: number;
}

export interface TestingVariant {
	name: string; // e.g. "LessButtons-B"
	experimentName: string; // e.g. "LessButtons"
	decisionPoints: DecisionPoint[];
}

export interface ExperimentDefinition {
	name: string;
	variants: {
		variant: TestingVariant;
		weight: number; // 0 to 1
	}[];
}



